import React from "react";

const PopupModal = props => {
  return (
    <div className={`${props.show ? "active popup-modal loading-modal" : ""}`}>
      <div className="dark-bg">{/* White frosty background */}</div>
      <div className="modal">
        <div class="modal-container">
          <button onClick={() => props.hideModal()} className="close-icon">
            <i class="material-icons">close</i>
          </button>
          <img src={props.icon} className="popup-icon" alt="" />
          <h2>{props.heading}</h2>
          <p dangerouslySetInnerHTML={{ __html: props.message }}></p>
          { props.buttonUrl == null ? "" :
          <a href={props.buttonUrl} className="button primary">
            {props.buttonText}
          </a>}
        </div>
      </div>
    </div>
  );
};

export default PopupModal;



// WEBPACK FOOTER //
// ./src/components/popupModal/popupModal.component.js